// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

// Common invalidate queries for sales orders.
const commonInvalidateQueries = (queryClient) => {
  // Invalidate sales orders.
  queryClient.invalidateQueries(t.SALES_ORDERS);
  queryClient.invalidateQueries(t.SALES_ORDER);

  // Invalidate customers.
  queryClient.invalidateQueries(t.CUSTOMERS);
  queryClient.invalidateQueries(t.CUSTOMER);

  // Invalidate items.
  queryClient.invalidateQueries(t.ITEMS);
  queryClient.invalidateQueries(t.ITEM);

  // Invalidate settings.
  queryClient.invalidateQueries([t.SETTING, t.SETTING_SALES_ORDERS]);

  // Invalidate transactions/reports that may depend on sales orders.
  queryClient.invalidateQueries(t.FINANCIAL_REPORT);
  queryClient.invalidateQueries(t.TRANSACTIONS_BY_REFERENCE);

  // Invalidate accounts.
  queryClient.invalidateQueries(t.ACCOUNTS);
  queryClient.invalidateQueries(t.ACCOUNT);

  // Invalidate reconcile.
  queryClient.invalidateQueries(t.RECONCILE_CREDIT_NOTE);
  queryClient.invalidateQueries(t.RECONCILE_CREDIT_NOTES);

  // Invalidate item warehouses.
  queryClient.invalidateQueries(t.ITEM_WAREHOUSES_LOCATION);

  // Invalidate mutate base currency abilities.
  queryClient.invalidateQueries(t.ORGANIZATION_MUTATE_BASE_CURRENCY_ABILITIES);
};

/**
 * Fetches the given sales order item details.
 */
export function useSalesOrderItemDetails(
  orderId,
  itemId,
  props,
  requestProps,
) {
  return useRequestQuery(
    [t.SALES_ORDER, orderId, 'ITEM', itemId],
    {
      method: 'get',
      url: `sales-orders/${orderId}/items/${itemId}`,
      ...requestProps,
    },
    {
      select: (res) => res.data,
      defaultData: {},
      ...props,
    },
  );
}

/**
 * Edits the given sales order item.
 */
export function useSalesOrderItem(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([orderId, itemId, values]) =>
      apiRequest.put(`sales-orders/${orderId}/items/${itemId}`, values),
    {
      onSuccess: (res, [orderId]) => {
        // Invalidate specific sales order.
        queryClient.invalidateQueries([t.SALES_ORDER, orderId]);
        // Common invalidate queries.
        commonInvalidateQueries(queryClient);
      },
      ...props,
    },
  );
}

/**
 * Creates the given sales order item structure (lineItems/stages/etc) for an existing item entry.
 */
export function useCreateSalesOrderItem(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([orderId, itemId, values]) =>
      apiRequest.post(`sales-orders/${orderId}/items/${itemId}`, values),
    {
      onSuccess: (res, [orderId]) => {
        queryClient.invalidateQueries([t.SALES_ORDER, orderId]);
        commonInvalidateQueries(queryClient);
      },
      ...props,
    },
  );
}
